import { Fragment } from "react";
import { FormControl, InputLabel, TextField, Typography, InputAdornment, } from "@mui/material";

function InputField(props) {
  const {
    inputRef,
    variant,
    size,
    dir,
    label,
    labelIcon,
    placeholder,
    defaultValue,
    value,
    register,
    error,
    rows,
    multiline,
    type,
    slotProps,
    disabled,
    onInput,
    onBlur,
    helperText,
    style,
    id,
    inputStyle,
    startAdornment,
    endAdornment,
    labelStyle
  } = props;

  return (
    <Fragment>
      {label && (
        <InputLabel error={error && true} sx={{ textTransform: "capitalize", fontSize: "14px", fontWeight: "600", color: "#5b6670", ...labelStyle }}>
          {labelIcon && (
            <img src={labelIcon} alt="" width={"13px"} height={"13px"} />
          )}
          {label}
        </InputLabel>
      )}
      <FormControl
        variant="standard"
        fullWidth
        sx={{ mt: 1, ...style, ".MuiFormHelperText-root": { ml: 0 } }}
      >
        <TextField
          // label={label}
          inputRef={inputRef}
          variant={variant ?? "outlined"}
          size={size ?? "small"}
          dir={dir}
          value={value}
          type={type}
          disabled={disabled}
          placeholder={placeholder || label}
          defaultValue={defaultValue}
          id={id}
          error={error && true}
          multiline={multiline}
          rows={rows}
          onBlur={onBlur}
          slotProps={{
            input: {
              startAdornment: (
                startAdornment && (
                  <InputAdornment position="start">
                    {startAdornment}
                  </InputAdornment>
                )
              ),
              endAdornment: (
                endAdornment && (
                  <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                    {endAdornment}
                  </InputAdornment>
                )
              ),
              ...slotProps,
            }
          }}
          onInput={onInput}
          helperText={helperText}
          {...register}
          sx={{
            "& input::placeholder": {
              fontSize: "14px",
            },
            ...inputStyle
          }}
        />
        {error && (
          <Typography variant="caption" color="error" sx={{ textAlign: 'left' }}>{error}</Typography>
        )}
      </FormControl>
    </Fragment>
  );
}

export default InputField;
